import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LanguageState } from '@store/reducers';

export const selectLanguageState = createFeatureSelector<LanguageState>('language');

export const selectLanguageLoading = createSelector(
  selectLanguageState,
  (state: LanguageState) => state.loading
);

export const selectLanguageCurrent = createSelector(
  selectLanguageState,
  (state: LanguageState) => state.currentLanguage
);

export const selectLanguageAvailable = createSelector(
  selectLanguageState,
  (state: LanguageState) => state.availableLanguages
);

export const selectLanguageTranslations = createSelector(
  selectLanguageState,
  (state: LanguageState) => state.translations
);

export const selectLanguageError = createSelector(
  selectLanguageState,
  (state: LanguageState) => state.error
);